<template>
  <div class="headerTopComp">

    <button v-if="!isSigninView" class="btn_menu" @click="$store.commit('showNavbar')">
      <img id="menu" src="../assets/menu@2x.png">
      <img id="menu_min" src="../assets/menu.png">
    </button>

    <div v-if="isSigninView"></div>
    <div class="div_logo">
      <img id="logo_1" src="../assets/logo-copy.png">
      <img id="logo_2" src="../assets/vip-v.png">
      <img id="logo_min" src="../assets/vip-vending.png">
    </div>
    <div v-if="isSigninView"></div>
    <div id="div_1"></div>
    <div class="div_btn">
      <button-comp v-if="!isSigninView" :textBtn="'Выход'" :classBtn="'btn_white'" :clickBtn="signOut"/>
    </div>
    <div v-if="!isSigninView" class="div_search">
      <!-- <img id="search" src="../assets/white-magnifier@2x.png">
      <img id="search_min" src="../assets/white-magnifier.png"> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerTopComp',
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  props: {
    isSigninView: {
      type: Boolean,
      default: function () { return false }
    }
  },
  computed: {
  },
  methods: {
    signOut () {
      this.$store.dispatch('auth/signOut')
    }
  }
}
</script>

<style scoped lang="scss">

.headerTopComp {
  // z-index: 1000;
  width: 100%;
  height: 90px;
  object-fit: contain;
  background-image: linear-gradient(to left, #ff4a00, #ff8200);

  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto 1fr auto;
}
.btn_menu {
  display: none;
}
.btn_menu:active {
  opacity: 0.5;
}
.div_logo {
  margin: 16px 32px;
}
.div_btn {
  margin: 24px 32px;
}
.div_search {
  display: none;
}
#logo_1 {
  float: left;
  margin-right: 32px;
}
#logo_2 {
  float: left;
}
#logo_min, #menu_min, #search_min {
  display: none;
}
@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
  .headerTopComp {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr auto 1fr;
  }
  .btn_menu {
    display: block;
    margin: auto auto auto 16px;
  }
  .div_logo {
    margin: 16px auto;
  }
  .div_btn {
    display: none;
  }
  .div_search {
    display: block;
    margin: auto 16px auto auto;
  }
  #div_1 {
    display: none;
  }
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .headerTopComp {
    height: 70px;
  }
  .div_logo{
    margin: auto auto 10px auto;
  }
  .btn_menu{
    margin: auto auto 15px 16px;
  }
  .div_search {
    margin: auto 16px 15px auto;
  }
  #logo_1, #logo_2, #menu, #search {
    display: none;
  }
  #logo_min, #menu_min, #search_min {
    display: block;
    width: auto;
    margin: auto;
  }
  #logo_min {
    height: 32px;
  }
}
@media screen and (max-width: 320px){
}
</style>
